module.exports = __webpack_public_path__ + "static/media/affidea.febb2abc.png";